// Blocks AI routes when CivilGEO has disabled AI for the signed-in user's company.
// Mirrors the nav-hiding logic: companyAiEnabled comes from /api/ai/me (global ∧ company,
// independent of the user's own allocation). Fail-open on error so a transient API hiccup
// doesn't lock users out. Direct-URL access to /app/ai* is redirected to the dashboard.
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

import LoadingScreen from "src/components/LoadingScreen";
import { getMyAiUsage } from "src/api/aiCustomerApi";

const AiEnabledGuard = ({ children }) => {
  const [status, setStatus] = useState("loading"); // loading | allowed | blocked

  useEffect(() => {
    let active = true;
    getMyAiUsage()
      .then(d => { if (active) setStatus(d && d.companyAiEnabled === false ? "blocked" : "allowed"); })
      .catch(() => { if (active) setStatus("allowed"); }); // fail-open
    return () => { active = false; };
  }, []);

  if (status === "loading") return <LoadingScreen />;
  if (status === "blocked") return <Redirect to="/app" />;
  return <>{children}</>;
};

AiEnabledGuard.propTypes = {
  children: PropTypes.node
};

export default AiEnabledGuard;
